import { mergeProps, useRender } from '@base-ui/react';

import { clsx } from '~/styles/utils';

import { cardSizeStyles, cardStyle, cardVariantStyles } from './Card.css';

type Props = useRender.ComponentProps<'div'> & {
  size?: 'small' | 'medium';
  variant?: 'white' | 'primary-brand' | 'primary-light' | 'primary-subtle' | 'primary-accent' | 'secondary-brand' | 'secondary-light';
};

export const CardRoot = ({ render, size = 'medium', variant = 'white', ...delegated }: Props) => {
  return useRender({
    defaultTagName: 'div',
    render,
    props: mergeProps<'div'>(
      {
        className: clsx(cardStyle, cardVariantStyles[variant], cardSizeStyles[size]),
      },
      delegated,
    ),
  });
};
